































import Vue from 'vue';
import Component from 'vue-class-component';

declare const CSRF_TOKEN: string;

@Component
export default class UploadFile extends Vue {
  csrf_tok = CSRF_TOKEN;
  uploadVisible = false;
  uploadFileList = [];
  loading = false;
  failedTableVisible = false;
  failedUserList: Record<any, any>[] = [];

  successUpload(response: any) {
    this.loading = false;
    if (response.ok) {
      this.failedUserList = response.result.fail_list;
      if (this.failedUserList.length === 0) {
        this.$notify.success('全部添加成功!');
        this.uploadVisible = false;
        this.failedTableVisible = false;
      } else {
        this.$message.error('部分员工添加失败');
        this.failedTableVisible = true;
      }
    } else {
      this.$notify.error(response.error.message);
      this.uploadFileList = [];
    }
  }

  errorUpload() {
    this.$notify.error('上传失败，请重试');
  }

  show() {
    this.uploadVisible = true;
  }

  submitUpload() {
    (this.$refs as any).upload.submit();
  }
}
